import api from './api';
import { unwrapApiResponse } from '@/utils/api-response.util';

export interface ExpertPrompt {
  id: number;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface ExpertPromptsPage {
  data: ExpertPrompt[];
  meta: { total: number; page: number; limit: number };
}

export interface CreateExpertPromptDto {
  title: string;
  content: string;
}

export interface UpdateExpertPromptDto {
  title?: string;
  content?: string;
}

export const expertPromptsService = {
  async getAll(page: number, limit: number, search?: string): Promise<ExpertPromptsPage> {
    const response = await api.get('/expert/prompts', {
      params: { page, limit, ...(search ? { search } : {}) },
    });
    return response.data;
  },

  async create(dto: CreateExpertPromptDto): Promise<ExpertPrompt> {
    const response = await api.post('/expert/prompts', dto);
    return unwrapApiResponse<ExpertPrompt>(response.data);
  },

  async update(id: number, dto: UpdateExpertPromptDto): Promise<ExpertPrompt> {
    const response = await api.patch(`/expert/prompts/${id}`, dto);
    return unwrapApiResponse<ExpertPrompt>(response.data);
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/expert/prompts/${id}`);
  },
};
